import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M306.204615,1607.00929 L1596.80189,1607.00929 L1403.20385,1800.61266 L1522.5879,1920 L1920,1522.57695 L1522.5879,1125.15389 L1403.20385,1244.54123 L1596.80189,1438.1446 L306.204615,1438.1446 L306.204615,1607.00929 Z M695.866039,787.669359 L729.215897,787.669359 L729.215897,1234.82307 L898.075935,1234.82307 L898.075935,168.864693 L1094.79788,168.864693 L1094.79788,1234.82307 L1263.65792,1234.82307 L1263.65792,168.864693 L1435.05086,168.864693 L1435.05086,0 L695.866039,0 C478.71203,0 302,176.632469 302,393.792464 C302,611.036891 478.71203,787.669359 695.866039,787.669359",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextDirectionLtrSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTextDirectionLtrSolid, _Component);

  var _super = _createSuper(IconTextDirectionLtrSolid);

  function IconTextDirectionLtrSolid() {
    _classCallCheck(this, IconTextDirectionLtrSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextDirectionLtrSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextDirectionLtr",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextDirectionLtrSolid.displayName = "IconTextDirectionLtrSolid";
  return IconTextDirectionLtrSolid;
}(Component);

IconTextDirectionLtrSolid.glyphName = 'text-direction-ltr';
IconTextDirectionLtrSolid.variant = 'Solid';
IconTextDirectionLtrSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextDirectionLtrSolid;
export { IconTextDirectionLtrSolid };